import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import VehicleLeftPanel from './VehicleLeftPanel';
import PricingBlock from './PricingBlock';
import PaymentHistoryBlock from './PaymentHistoryBlock';
import VehicleTitleBlock from './VehicleTitleBlock';
import { getEasyPayStatus } from '../utils/easyPayStatus';

type QueryEndpoint = 'getAllBuyerTransactions' | 'getEasyPayBuyerTransactions' | 'getCardBuyerTransactions';
type ReduxTab = 'all' | 'easyPay' | 'card';

interface TransactionRecordCardProps {
  vehicle: any;
  queryEndpoint: QueryEndpoint;
  reduxTab: ReduxTab;
}

const Card = styled.div`
  display: flex;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  gap: 24px;
`;

const MiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  gap: 0;
`;

const BlockSeparator = styled.div`
  height: 24px;
`;

const EasyPayButton = styled.button`
  width: 100%;
  margin-top: auto;
  padding: 14px;
  background: #d9d9d9;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  height: 44px;
  color: #000;
  cursor: pointer;
  letter-spacing: 0.5px;
`;

const StatusLabel = styled.div<{ color?: string; textColor?: string }>`
  width: 100%;
  margin-top: auto;
  padding: 14px;
  background: ${({ color }) => color ?? '#d9d9d9'};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  height: 44px;
  color: ${({ textColor }) => textColor ?? '#000'};
  text-align: center;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 320px;
  max-height: 600px;
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
`;

const getEasyPayArea = (vehicle: any, onEasyPay: () => void) => {
  const status = getEasyPayStatus(vehicle);

  if (status.kind === 'paid') {
    return <StatusLabel color="#4caf50" textColor="#fff">PAID</StatusLabel>;
  }

  if (status.kind === 'pending') {
    return <StatusLabel color="#CA8D57" textColor="#fff">{status.label}</StatusLabel>;
  }

  return <EasyPayButton onClick={onEasyPay}>EASYPAY</EasyPayButton>;
};

const TransactionRecordCard = ({ vehicle, queryEndpoint, reduxTab }: TransactionRecordCardProps) => {
  const history = useHistory();

  return (
    <Card>
      <VehicleLeftPanel
        vehicle={vehicle}
        onImageClick={() => history.push(`/vehicles/${vehicle.id}/view`)}
        showAwarded={vehicle.status === 'awarded'}
      />
      <MiddleContainer>
        <PricingBlock vehicle={vehicle} />
        <BlockSeparator />
        <PaymentHistoryBlock vehicle={vehicle} />
        <BlockSeparator />
        {getEasyPayArea(vehicle, () => history.push(`/buyer/bids/${vehicle.id}/easy-pay`))}
      </MiddleContainer>
      <RightPanel>
        <VehicleTitleBlock vehicle={vehicle} queryEndpoint={queryEndpoint} reduxTab={reduxTab} />
      </RightPanel>
    </Card>
  );
};

export default TransactionRecordCard;
